<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="cssLayoutRowStartCenter">
  <b>Scoring Options</b>
</div>

<div class="mat-elevation-z2">
  <div class="header-row">
    <span class="header-cell eight-cell">
      <button mat-icon-button (click)="addOrEditScoringOption(null); $event.stopPropagation()"
        style="outline: none; margin-left: 20px;" title="Add Scoring Option" [disabled]="!canEdit">
        <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle"></mat-icon>
      </button>
      <span style="margin-left: 20px;">Description</span>
    </span>
    <span class="header-cell one-cell center-text">Value</span>
    <span class="header-cell one-cell center-text">Order</span>
    <span class="header-cell one-cell center-text">Modifier</span>
  </div>

  @for (scoringOption of scoringOptionList; track scoringOption) {
  <div>
    @if (!isLoading) {
    <div class="row">
      <div class="cell eight-cell">
        <button mat-icon-button (click)="addOrEditScoringOption(scoringOption); $event.stopPropagation()"
          style="outline: none;" title="Edit Scoring Option" [disabled]="!canEdit">
          <mat-icon class="mdi-24px self-center" fontIcon="mdi-square-edit-outline"></mat-icon>
        </button>
        <button mat-icon-button (click)="deleteScoringOptionRequest(scoringOption); $event.stopPropagation()"
          style="outline: none;" title="Delete Scoring Option" [disabled]="!canEdit">
          <mat-icon class="mdi-24px self-center" fontIcon="mdi-trash-can-outline"></mat-icon>
        </button>
        <span class="center-self">
          {{ scoringOption.description }}
        </span>
      </div>
      <div class="one-cell  center-text">
        {{ scoringOption.value }}
      </div>
      <div class="one-cell  center-text">
        {{ scoringOption.displayOrder }}
      </div>
      <div class="one-cell  center-text">
        <mat-checkbox [(ngModel)]="scoringOption.isModifier" [disabled]="true"></mat-checkbox>
      </div>
    </div>
    }
  </div>
  }
</div>

@if (isLoading) {
<mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</mat-card>
}
